import i18next from "i18next";
import common_en from "./assets/translations/en/common.json";
import common_es from "./assets/translations/es/common.json";
import {initReactI18next} from 'react-i18next';

i18next
    .use(initReactI18next)
    .init({
        interpolation: {escapeValue: false},
        lng: 'en',                              // language to default
        resources: {
            en: {
                common: common_en
            },
            es: {
                common: common_es
            },
        },
    }).then(r => true);

export default i18next;
